import { request } from './request';

export async function getAddressDetailsFromSearchLocation(
  searchLocation,
  resultCount = 5,
  abortController,
  handleErrorResponse,
) {
  const mapAddressComponents = (addressComponents) => {
    return addressComponents.reduce((result, addressComponent) => {
      const componentType = addressComponent.administrative_type || addressComponent.type;
      const componentValue = addressComponent.long_name;
      switch (componentType) {
        case 'street_number':
          result.streetNumber = componentValue;
          break;
        case 'route':
          result.street = componentValue;
          break;
        case 'suburb':
        case 'sublocality_level_1':
        case 'sublocality_level_2':
          result.suburb = componentValue;
          break;
        case 'town':
        case 'locality':
          result.city = componentValue;
          break;
        case 'province':
        case 'administrative_area_level_1':
          result.province = componentValue;
          break;
        case 'country':
          result.country = componentValue;
          break;
        case 'post_street':
        case 'postal_street_code':
        case 'postal_code':
          result.postalCode = componentValue;
          break;
        case 'unit':
          result.unit = componentValue;
          break;
        case 'building':
          result.building = componentValue;
          break;
      }
      return result;
    }, {});
  };

  const res = await request(
    `geocode/address?ilsGroups=address_component&ilsLocation=${searchLocation}&ilsResultCount=${resultCount}`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    false,
    false,
    false,
  );

  const isAborted = !!abortController && abortController.signal.aborted;
  if (res.status === 200) {
    return (res.result?.results || []).map((resultItem, index) => ({
      index: index,
      addressName: resultItem.formatted_address,
      address: mapAddressComponents(resultItem.address_components),
      coordinates: resultItem.geometry.location,
    }));
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse();
  }
}
